import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ReportParagraphsService } from '../report-paragraphs-service';
import { ReportParagraphsRepository } from '../report-paragraphs-repository';
import type { SpecChapter } from '../../types';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class ReportParagraphsServiceImpl implements ReportParagraphsService {

    constructor(
        @inject(ReportParagraphsRepository)
        private _reportParagraphsRepository: ReportParagraphsRepository,
        @inject(CurrentTaskService)
        private _currentTaskService: CurrentTaskService,
    ) {}

    async getChaptersAndParagraphs(): Promise<SpecChapter[]> {
        const taskId = this._currentTaskService.taskId;
        const chapters = await this._reportParagraphsRepository.fetchSpecChapter(taskId);
        return chapters;
    }
}
